<template>
  <nav v-if="pages > 1" class="pages pagination">
    <a
      v-on:click.left="to(1)"
      :disabled="value == 1"
      >&lt;&lt;</a><a
      v-on:click.left="to(Math.max(value-1, 1))"
      class="around"
      :disabled="value == 1"
      >&lt;</a>

    <a
      v-for="pg in shownpages"
      v-on:click.left="to(pg)"
      :disabled="pg == value"
      :class="{around:Math.abs(pg - value) <= 3}"
      >{{ pg }}</a>

    <a
      v-on:click.left="to(Math.min(pages, value+1))"
      :disabled="value == pages"
      class="around"
      >&gt;</a><a
      v-on:click.left="to(pages)"
      :disabled="value == pages"
      >&gt;&gt;</a>
  </nav>
</template>

<script>
  export default {
    name: 'Pages',
    props: ['value', 'pages'],
    computed: {
      shownpages () {
        var ppp = [];
        for (let i = 1; i <= this.pages; i++) {
          if (i < 5) {
            ppp.push(i);
          } else if (Math.abs(Number(this.pages) - i) < 5) {
            ppp.push(i);
          } else if (Math.abs(i - this.value) < 5) {
            ppp.push(i);
          }
        }
        return ppp;
      },
    },
    methods: {
      to (pg) {
        this.$emit('input', pg);
      },
    }
  }
</script>

<style lang="scss">
  nav.pages.pagination {
    padding-top: 8px;
    padding-bottom: 8px;
    text-align: right;
    &.center {
      text-align: center;
    }
    $stick: 3;
    a {
      cursor: pointer;
      display: inline-block;
      vertical-align: middle;
      @include font-size(18px, 20px);
      padding: 0 4px;
      min-width: 31px;
      font-weight: 700;
      color: mix($body-bg, $accent-color);
      border: solid 2px $body-bg;
      text-align: center;
      margin: 2px 1px;
      &[disabled] {
        cursor: default;
        color: $accent-color;
      }
      &:nth-child(1), &:nth-child(2), &:nth-last-child(1), &:nth-last-child(2) {
        font-weight: 400;
      }
      display: none;
      &.around, &:nth-child(-n+#{$stick}), &:nth-last-child(-n+#{$stick}) {
        display: inline-block !important;
      }
      &:nth-child(#{$stick+1}):not(.around), &:nth-last-child(#{$stick+1}):not(.around) {
        display: inline-block !important;
        font-size: 0;
        //color: transparent !important;
        border: none;
        &::after {
          content: '...';
          @include font-size(18px, 20px);
          vertical-align: middle;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/helpers/mixins/pagination/Pages.vue